import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "work" }
const _hoisted_2 = { class: "work_title" }
const _hoisted_3 = { class: "work_btn" }

import { message, Modal } from 'ant-design-vue';
import { reactive, ref } from 'vue';
import api from '@/api/home';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeMask',
  setup(__props) {

const aModal = Modal;
const router = useRouter();

const tipModal = reactive({
  title: '提示',
  loading: false,
  renewVisible: true,
});

const handleCancel = () => {
  Modal.confirm({
    title: () => '确认再使用十五天吗?',
    centered: true,
    okText: '确认',
    cancelText: '取消',
    onOk() {
      api
        .setVersionStatus()
        .then(() => {
          router.push('/home');
        })
        .catch((err) => {
          message.error(err.data.error);
        });
    },
    onCancel() {
      console.log('Cancel');
    },
  });
};
const handleOk = () => {
  router.push('/wallet/version');
};

const useContinue = ref(false);
const getVersionStatus = async () => {
  try {
    const versionData = await api.getVersionStatus();
    useContinue.value = Boolean(!versionData.data.data.continue);
  } catch (err: any) {
    console.error(err?.data?.error);
  }
};
getVersionStatus();

const clickHref = () => {
  window.open(
    'https://www13.53kf.com/webCompany.php?arg=10561881&kf_sign=TYxMTMTY1OA2MTI1NDIyNTgwNzAwMTM3MjU2MTg4MQ%253D%253D&style=1'
  );
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mask" }, [
      _createElementVNode("div", { class: "grayscale" }, [
        _createElementVNode("div")
      ])
    ], -1)),
    _createVNode(_unref(aModal), {
      visible: tipModal.renewVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((tipModal.renewVisible) = $event)),
      title: tipModal.title,
      centered: "",
      footer: null,
      maskClosable: false,
      keyboard: false,
      closable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_svg_icon, {
              "icon-class": "warning",
              class: "work_title_icon"
            }),
            _cache[1] || (_cache[1] = _createTextVNode(" 续费提醒 ", -1))
          ]),
          _createElementVNode("p", null, [
            _cache[2] || (_cache[2] = _createTextVNode(" 您的版本已到期，可使用以下方式续费，联系我们", -1)),
            _createElementVNode("span", {
              class: "work_title_href",
              onClick: clickHref
            }, "官方客服"),
            _cache[3] || (_cache[3] = _createTextVNode("咨询或拨打官方电话", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "400-920-1599", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            key: "back",
            onClick: handleCancel,
            class: "work_btn_left",
            disabled: useContinue.value
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("再使用15天", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            key: "submit",
            type: "primary",
            loading: tipModal.loading,
            onClick: handleOk
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("购买版本", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})